// extracted by mini-css-extract-plugin
export default {"root":"PagesTableExpandedRow_root__6Hybd"};